import LargeProfile from './LARGE';
import { Navigate, Outlet } from 'react-router-dom';
import PageLoading from '../../PageLoading';
import { useAuth } from '../../hooks/contexts/AuthContext';
import ScrollToTop from '../../components/other/ScrollToTop';

const Index = () => {
  const { isLoggedIn, isLoading } = useAuth();

  if (isLoading) {
    return <PageLoading />;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <ScrollToTop />
      <LargeProfile>
        <Outlet />
      </LargeProfile>
    </>
  );
};

export default Index;
